var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroDividers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C7.95337 20 6.29534 17.2021 6.26943 13.7306C2.79793 13.7047 0 12.0466 0 10C0 7.95337 2.79793 6.29534 6.26943 6.26943C6.29534 2.79793 7.95337 0 10 0C12.0466 0 13.7047 2.79793 13.7306 6.26943C17.2021 6.29534 20 7.95337 20 10C20 12.0466 17.2021 13.7047 13.7306 13.7306C13.7047 17.2021 12.0466 20 10 20Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDividers);
export default __webpack_public_path__ + "static/media/hero-dividers.4fc3ef3bf0ca31dd340dd523769cce1f.svg";
export { ForwardRef as ReactComponent };